import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import InPersonPackages from "../components/InPersonPackages";
import VirtualPrograms from "../components/VirtualPrograms";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Services />
        <InPersonPackages />
        <VirtualPrograms />
        <About />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
